import React, { Component } from 'react';
import Modal from 'react-modal';
import PropTypes from 'prop-types'
import { PayPalButton } from "react-paypal-button-v2";
import './style.scss';
import { getPlans, validCode, userPayment, validateUser, updateProfile } from './actions';
import { Field, reduxForm, SubmissionError  } from 'redux-form'
import { Radio } from 'antd';
import WrappedIntlComponent from '../common/intl/WrappedIntlComponent';
import SelectField from '../helpers/Fields/SelectField';
import InputField from '../helpers/Fields/InputField';
import { required, email } from 'redux-form-validators'
import Spiner from '../helpers/Spiner/Spiner';
import {toastr} from 'react-redux-toastr'
import { connect } from 'react-redux'
import { isInitedSelector, logout } from '../../modules/app';
import { isAuthSelector, isAdminSelector, isOrganisationSelector, isTeacherOrganisationSelector } from '../../modules/profile';
import { showModalPayment } from '../../redux/actions';
import { withRouter } from "react-router";
import { formValueSelector } from 'redux-form'
import { updateTeacher } from '../UserOrganisation/actions';
import {orderBy} from 'lodash'

const selector = formValueSelector('payment_form')

class PaymentModal extends Component {
  static contextTypes = {formatMessage: PropTypes.any};

  constructor(props) {
    super(props)
    this.state = {
      plans: [],
      block: true,
      payment: false,
      isOpen: false,
      amount: 0,
      months: 0,
      compare_amount: 0,
      spinner: true,
      plan: {},
      data: {
      }
    }
  }
  

  async componentDidMount(){
    const {isAuth, isInited, isAdmin, isOrganisation} = this.props;    
    
    this.setState({
      block: true,
    });

    const plans = await getPlans();
    if(isAuth && isInited && !isAdmin && !isOrganisation){
      let valid = await validateUser();
      if(valid){
        this.setState({
          block: false,
          plans
        })
        return;
      }
      
      this.setState({
        isOpen: true,
        plans,
        block: false,
        spinner: false,
      })
    } else {
      this.setState({
        plans,
        block: false,
      })
    }
  }

  async componentWillReceiveProps(nextProps){
    try {
      if(!nextProps.isAdmin && !nextProps.isOrganisation && nextProps.isAuth && nextProps.isInited && this.props.isAuth != nextProps.isAuth){
        this.setState({
          block: true,
        })
        let valid = await validateUser();
        if(valid){
          this.setState({
            block: false,
          })
          return;
        }
        const plans = await getPlans();
        this.setState({
          isOpen: true,
          plans,
          spinner: false,
          block: false,
        })
      } else if(!nextProps.isAdmin && !nextProps.isAuth && nextProps.isInited && this.props.isAuth != nextProps.isAuth) {
        this.setState({
          isOpen: false,
          block: false,
        })
      }
  
      if(nextProps.show && nextProps.show != this.props.show){
        this.setState({
          isOpen: true,
          spinner: false,
          block: false,
        })
      }
    } catch (error) {
      this.setState({
        isOpen: false,
        spinner: false,
        block: false,
      });
    }
  }

  submit = async (values) => {
    const { formatMessage, isOrganisation } = this.props;
    try {
      const {plans} = this.state;
      

      let plan = {};

      let data = {}

      if(values.code){
        this.setState({
          spinner: true
        })
        let {valid, discount} = await validCode(values.code);
        if(!valid){
          this.setState({
            spinner: false
          });
          throw new SubmissionError({code: formatMessage('not_valid_code')})
          return;
        } else {
          data.discount = discount;
        }
      } else {
        this.setState({
          spinner: true
        })
        await new Promise((resolve, reject) => {
          setTimeout(() => {
            resolve(true)
          }, 800);
        })
        this.setState({
          spinner: false
        })
      }

      plans.some(i => {
        if(i.id == values.plan_id){
          plan = {...i};
        }
      });

      plan.compare_amount = plan.amount;

      if(plan.amount > 0){
        if(data.discount && data.discount.percentage){
          plan.amount = (plan.amount - (100/plan.amount*data.discount.percentage)).toFixed(2);
        }
      }

      data.plan = plan;

      if(plan.amount == 0){
        userPayment({
          data: JSON.stringify({...data, paypal: {}}),
          amount: plan.amount,
          months: plan.months,
          subscription: plan.title,
          procent: 0,
          promo_code: '',
          user_id: this.props.user_id,
        }).then(result => {
          if(isOrganisation){
            this.props.updateTeacher(result.user);
          } else {
            this.props.updateProfile(result.user);
          }
          // toastr.success(formatMessage('paymentTitleSuccess'), formatMessage('paymentSuccessMsg'));
          this.setState({spinner: false, isOpen: false})
        });
      } else {
        this.setState({
          amount: plan.amount,
          months: plan.months,
          compare_amount: plan.compare_amount,
          payment: true,
          spinner: true,
          data,
          plan
        })
      }

    } catch (error) {
      console.log("🚀 ~ file: index.jsx ~ line 207 ~ PaymentModal ~ submit= ~ error", error)
      if(error && error.name && error.name == 'SubmissionError'){
        throw new SubmissionError({code: formatMessage('not_valid_code')})
      }
      this.setState({
        isOpen: false,
        spinner: false,
        block: false,
      });
    }
  }

  render() {
    const {plans, block, isOpen, payment, amount, plan, spinner, compare_amount, months} = this.state;
    const { handleSubmit, formatMessage, show, location, planId, isTeacherOrganisation, user_id, isOrganisation, profile } = this.props;
    
    if(location.pathname.indexOf('404') > -1){
      return null;
    }


    let tmp_price = amount;

  


    plans.forEach(i => {
      if(i.id == planId){
        tmp_price = i.amount;
      }
    })

    const tpmPlans = orderBy(plans, ['amount'], ['asc']).filter(_i => !profile.payment_date_active ? true : _i.amount > 0)
    
    return (
      <React.Fragment>
        {block && <div className="spinner-blocked">
          <Spiner />
        </div>}
        {isTeacherOrganisation ? <Modal
          isOpen = {isOpen}
          style = {{
              overlay : {
                zIndex: 999999,
              },
          }}
          overlayClassName = "custom-modal payment-paypal-modal"
          className = "custom-modal-content create-dialog-modal-content"
        >
          <div className="create-dialog-modal-content__header">
            <div className="create-dialog-modal-content__title">{formatMessage('titlePaymentTeacherOrgnisation')}</div>
            <p style={{textAlign: 'center', marginTop: 10}}>{formatMessage('msgPaymentTeacherOrgnisation')}</p>
            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
              <button className="btn btn-info" onClick={() => this.props.logout()}>{formatMessage('msgLogout')}</button>
            </div>
          </div>
        </Modal> :
        <Modal
          isOpen = {isOpen}
          style = {{
              overlay : {
                zIndex: 999999
              },
          }}
          overlayClassName = "custom-modal payment-paypal-modal"
          className = "custom-modal-content create-dialog-modal-content"
        >
          <div className="create-dialog-modal-content__header">
            <div className="create-dialog-modal-content__title">{formatMessage('titlePayment')}</div>
          </div>
          <div className="create-dialog-modal-content__body" style={{padding: '5px 20px 0px'}}>
            <div className="PaymentModal">
              {spinner && <div className="spinner-block">
                <Spiner />
              </div>}
            
              {!payment && <form className="create-dialog-form" onSubmit={handleSubmit(this.submit)}>
                  <div className="img-logo-pay">
                    <img src="/images/pay-logo.png" alt="" />
                  </div>
                  <div className="amount" style={{textAlign: 'center', fontWeight: 'bold', fontSize: 24}}>{formatMessage('becomeProTeacherPaymentForm')}</div>
                  <div className="amount">{formatMessage('titleTotal')}: <span>${tmp_price} USD</span></div>
                  <Field
                    name="plan_id"
                    label={formatMessage('titlePlanPayment')}
                    component={SelectField}
                    options={tpmPlans.map(plan => ({title: plan.title, value: plan.id}))}
                    validate={[required()]}
                  />
                  <Field
                    name="code"
                    label={formatMessage('titlePromoCode')}
                    component={InputField}
                  />
                  <div className="actions">
                    <button
                        className="btn btn-primary"
                        type="submit"
                    >{formatMessage('btnPaymentTitleNext')}</button>
                    {show ? <button
                        className="btn btn-danger"
                        type="button"
                        onClick={() => {
                          this.setState({isOpen: false});
                          this.props.showModalPayment(false)
                        }}
                      >{formatMessage('btnPaymentTitleCancel')}</button>
                    : <button
                        className="btn btn-danger"
                        type="button"
                        onClick={() => this.props.logout()}
                    >{formatMessage('btnPaymentTitleLogout')}</button>}
                  </div>
              </form>}
              {payment && <div className="checkout">
                <div className="amount">{formatMessage('titleTotal')}: {compare_amount != amount && <span className="compare_amount">${compare_amount} USD</span>} <span>${amount} USD</span></div>
                
                <PayPalButton
                  amount={amount}
                  onButtonReady={() => {
                    this.setState({spinner: false});
                    
                  }}
                  onSuccess={(details, data) => {
                    this.setState({spinner: true})
                    try {
                      return userPayment({
                        data: JSON.stringify({...this.state.data, paypal: details}),
                        amount,
                        months,
                        subscription: plan.title,
                        procent: this.state.data.discount ? this.state.data.discount.percentage  : 0,
                        promo_code: this.state.data.discount ? this.state.data.discount.promo_code  : '',
                        user_id,
                      }).then(result => {
                        if(isOrganisation){
                          this.props.updateTeacher(result.user);
                        } else {
                          this.props.updateProfile(result.user);
                        }
                        toastr.success(formatMessage('paymentTitleSuccess'), formatMessage('paymentSuccessMsg'));
                        this.setState({spinner: false, isOpen: false})
                      });
                    } catch (error) {
                      toastr.error('paymentErrorTitle', 'paymentErrorMsg')
                    }
                  
                  }}
                  onError={(err) => {
                    toastr.error('paymentErrorTitle', 'paymentErrorMsg')
                  }}
                  onCancel={() => {
                    this.setState({payment: false})
                  }}
                  options={{
                    // clientId: "AQlQDJmkD2Yg33NKlhlmn4etua308HurrWByPD4m1cLNZWgb7qs_21Cx_zyJLn1y3h0L0WtoDUaJyRxz" // demo
                    // clientId: "AWIfPGwMCo76Ufsxbhn8p1Y2nn36T47_eAWzSzwng54ITP7ARjbhUWv61b3hqVb6_RSVAQ8Or9S9AwCF"
                    clientId: "AaeB1J6lYeIszt764_zJRd5ciu9DHC3p_qIr3uyqPp9o9K1AjZG45ktnO7N6ILhwEEx1Kg2F5Rf8k4uX" // online school paypal
                  }}
                />
                <button
                  className="btn btn-cansel"
                  type="button"
                  onClick={() => {this.setState({payment: false})}}
                >{formatMessage('btnPaymentTitleBack')}</button>
              </div>}
            
            </div>
          </div>
        </Modal>
        }
      </React.Fragment>
    );
  }
}

PaymentModal = reduxForm({
  form: 'payment_form'
})(PaymentModal)




const mapStateToProps = (state, ownProps) => ({
  isInited : isInitedSelector(state),
  isAuth : isAuthSelector(state),
  isAdmin : isAdminSelector(state),
  isOrganisation : isOrganisationSelector(state),
  isTeacherOrganisation : isTeacherOrganisationSelector(state),
  planId: selector(state, 'plan_id'),
  show: state.payment.show,
  user_id: state.payment.user_id,
  profile: state.profile.entity,
})

const mapDispatchToProps = {
  logout,
  showModalPayment,
  updateProfile,
  updateTeacher,
}

export default withRouter(WrappedIntlComponent(connect(mapStateToProps, mapDispatchToProps)(PaymentModal)));



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/PaymentModal/index.jsx